class ModuleEntitiesStep {
  checkBoxDisable(modalId) {
    this.cleanCheckBox(modalId)

    if (this.check_adm && this.check_adm.checked) {
      this.checkModules(this.check_adm.checked)
    }
  }

  headerMessage(modalId, userEmail) {
    const modulesText = `Quais módulos das suas empresas ${this.emailSpanElement(userEmail)} poderá acessar?`
    this.jQuery(`#${modalId} .modules-text`).html(modulesText)
  }

  emailSpanElement(userEmail) {
    return `<span style="color: #6193ee">${userEmail}</span>`
  }

  cleanCheckBox(modalId) {
    this.jQuery(`[id^="${modalId}_form_module_entities_"]`).each(function enable() {
      this.checked = false
      this.disabled = false
    })

    this.jQuery('.module-entities-table input[type=checkbox]:not(:disabled)').prop('checked', false)
  }

  checkModules(boolean) {
    document.querySelectorAll("*[id^='invites_form_module_entity_ids_']").forEach((element) => {
      const el = element

      el.checked = boolean
      el.disabled = boolean
    })
  }
}

export default ModuleEntitiesStep
